import Backbone from 'backbone/backbone'
import _ from 'underscore/underscore'

import BaseView from 'front/components/BaseView/BaseView.js'

import './Cookie.css'
import template from './Cookie.jinja'


var Cookie = BaseView.extend({
    el: '.Cookie',
    events: {
        'click .Cookie-button': 'closeCookie'
    },

    initialize (options) {
        _.bindAll(this, 'closeCookie', 'deactivate');
        // this.parent = options.parent
    },

    closeCookie() {
        localStorage.setItem('offcon_cookie', 'true');
        this.deactivate();
    },

    activate() {
        const isCookieSet = !!localStorage.getItem('offcon_cookie');

        if (isCookieSet) {
            return;
        }

        $.Velocity.hook(this.$el, 'opacity', '0')
        $.Velocity.hook(this.$el, 'translateY', '200px')
        $.Velocity.hook(this.$el, 'translateX', '-50%')
        this.$el[0].style.display = 'inline-flex';

        return $.Velocity.animate(this.$el[0], {
            opacity: [1, 'linear'],
            translateY: [0, 'easeOutCubic'],
            translateX: ['-50%'],
        }, _.extend({duration: 500, delay: 500}))
    },

    deactivate() {
        var self = this
        return $.Velocity.animate(this.$el[0], {
            opacity: [0, 'linear'],
            translateY: ['200px', 'easeOutCubic'],
            translateX: ['-50%'],
        }, _.extend(
            {
                duration: 500,
                complete() {
                    self.$el[0].css('display', 'none')
                }
            }))
    }
})

export default Cookie;



// WEBPACK FOOTER //
// ./assets/app/front/components/Cookie/Cookie.js